<div class="card-body">
    <div id="apex-annotations-chart"></div>
</div>